import styled from 'styled-components';
import { m, ml, mr, mx, my, mt, mb, px } from '@lendi-ui/spacing';
import { heading, body, link } from '@lendi-ui/typography';
import { gte } from '@lendi-ui/breakpoint';
import { fg, color } from '@lendi-ui/color';
import { unit } from '@lendi-ui/grid';
import { depth } from '@lendi-ui/depth';

export const Article = styled.article`
  display: flex;
  flex-direction: column;
  ${gte('desktop')`
    ${my('xl')}
    ${px('xxs')}
    flex-direction: row;
  `}
`;

export const FigureLink = styled.a`
  overflow: hidden;
  width: 100%;
  ${gte('desktop')`
    ${unit({ size: 0.4 })}
    ${depth(1)}
    background-position: 100% 50%;
    border-radius: 6px;
    height: 320px;
    flex-shrink: 0;
  `}
`;

export const Figure = styled.figure`
  ${m('nil')}
  overflow: hidden;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: 50% 50%;
`;

export const Summary = styled.section`
  ${mx({ mobile: 'sm', desktop: 'lg' })}
  ${my('sm')}
  border-bottom: 1px solid ${color('shade.100')};
  ${gte('desktop')`
    border: none;
  `}
`;

export const CategoryLink = styled.a`
  text-decoration: none;
`;

export const Category = styled.p`
  ${body({ size: 'xs', color: 'primary.500' })}
  ${m('nil')}
  text-transform: uppercase;
  cursor: pointer;
`;

export const Alink = styled.a`
  ${link()}
  ${fg('shade.700')}
  text-decoration: none;
  :active {
    text-decoration: none;
  }
`;

export const Heading = styled.h1`
  ${heading({ size: 'md' })}
  ${mt('sm')}
  ${mb('xs')}
`;

export const BlogInfo = styled.section`
  ${body({ size: 'xs' })}
  ${fg('shade.500')}
`;

export const Author = styled.span`
  font-weight: 600;
`;

export const AuthorInfo = styled.span`
  ${mr('xxxs')}
`;

export const ReadTimeInfo = styled.span`
  ${ml('xxxs')}
`;

export const Overview = styled.section`
  ${body({ size: 'md' })}
  ${my('sm')}
`;
